const toggles = document.querySelectorAll('input[type="checkbox"][data-toggle="vat"]')

const toggleVat = function (event) {
  const input = event.target

  if (!input || !(input instanceof HTMLInputElement)) {
    return
  }

  // disable the inputs to prevent further changes while the request is in progress
  for (const input of toggles) {
    input.disabled = true
    input.classList.add('disabled')
  }

  fetch(input.dataset.url, {
    method: 'POST',
    body: new URLSearchParams({ _token: input.dataset.token }),
  })
    .then((response) => {
      if (response.status === 205) {
        // Reset Content - reload the page to reflect the new VAT setting
        window.dispatchEvent(new CustomEvent('vat-toggle'))
        location.reload()
      } else if (response.status === 204) {
        // No Content - revert the toggle state and leave it disabled to prevent further changes
        input.checked = !input.checked
      } else {
        // Error - revert the toggle state and throw an error to be caught below
        input.checked = !input.checked

        throw new Error(`Unexpected response: ${response.status}`)
      }
    })
    .catch((error) => console.error(error))
}

if (toggles.length > 0) {
  document.addEventListener('DOMContentLoaded', () => {
    for (const input of toggles) {
      input.addEventListener('change', toggleVat)
    }
  })
}
